const l = {
  name: "ProductTeam",
  dimensions: { width: 24, height: 24 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M18,8.4l-6-3.6L6,8.4v7.1l6,3.6l6-3.6V8.4z M8,10.8l3,1.8v3.7l-3-1.8V10.8z M13,16.2v-3.7l3-1.8v3.7L13,16.2z
			 M12,10.8L8.9,9L12,7.2L15.1,9L12,10.8z"/>
		<path class="st0" d="M14.3,0H9.7L9.2,2.4c-0.7,0.2-1.4,0.5-2,0.8l-2-1.4L1.9,5.2l1.4,2c-0.4,0.6-0.6,1.3-0.8,2L0,9.7v4.6l2.4,0.5
			c0.2,0.7,0.5,1.4,0.8,2l-1.4,2l3.3,3.3l2-1.4c0.6,0.4,1.3,0.6,2,0.8L9.7,24h4.6l0.5-2.4c0.7-0.2,1.4-0.5,2-0.8l2,1.4l3.3-3.3
			l-1.4-2c0.4-0.6,0.6-1.3,0.8-2l2.4-0.5V9.7l-2.4-0.5c-0.2-0.7-0.5-1.4-0.8-2l1.4-2l-3.3-3.3l-2,1.4c-0.6-0.4-1.3-0.6-2-0.8L14.3,0
			z M10.9,4l0.4-2h1.4l0.4,2l0.6,0.1c0.9,0.2,1.8,0.6,2.6,1.1l0.5,0.4l1.8-1.2l1,1l-1.2,1.8l0.4,0.5c0.5,0.8,0.9,1.6,1.1,2.6
			l0.1,0.6l2,0.4v1.4l-2,0.4l-0.1,0.6c-0.2,0.9-0.6,1.8-1.1,2.6l-0.4,0.5l1.2,1.8l-1,1l-1.8-1.2l-0.5,0.4c-0.8,0.5-1.6,0.9-2.6,1.1
			L13.1,20l-0.4,2h-1.4l-0.4-2l-0.6-0.1c-0.9-0.2-1.8-0.6-2.6-1.1l-0.5-0.4l-1.8,1.2l-1-1l1.2-1.8l-0.4-0.5
			c-0.5-0.8-0.9-1.6-1.1-2.6L4,13.1l-2-0.4v-1.4l2-0.4l0.1-0.6c0.2-0.9,0.6-1.8,1.1-2.6l0.4-0.5L4.4,5.4l1-1l1.8,1.2l0.5-0.4
			c0.8-0.5,1.6-0.9,2.6-1.1L10.9,4z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as ProductTeam
};
